














import {
  mdiCheckCircleOutline,
  mdiCloseCircle,
  mdiAlertCircleOutline,
} from '@mdi/js';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getFileLink } from '@/api/filestorage';
import StatusInfo from '@/components/elements/statement/Status/StatusInfo.vue';
import StatusIcon from '@/components/elements/statement/Status/StatusIcon.vue';
import StatusAdditionalSigners from '@/components/elements/statement/Status/StatusAdditionalSigners.vue';
// eslint-disable-next-line no-unused-vars
import { IStatementStatusInfo } from '@/utils/types';

@Component({
  components: { StatusIcon, StatusInfo, StatusAdditionalSigners },
  data() {
    return {
      mdiCheckCircleOutline,
      mdiCloseCircle,
      mdiAlertCircleOutline,
      getFileLink,
    };
  },
})
export default class ResultView extends Vue {
  @Prop() status!: IStatementStatusInfo;

  get currentStatus() {
    return this.status.statusHistory.filter(
      (item: any) => item.statusCode === this.status.statusCode
    )[0];
  }
}
